<template>
  <div class="CarType">
    <a-carousel ref="carousel" arrows :infinite="false" :dots="false">
      <div
        slot="prevArrow"
        class="custom-slick-arrow"
        style="left: 10px;zIndex: 1"
      >
        <div class="itemIcon left">
          <a-icon type="left" />
        </div>
      </div>
      <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
        <div class="itemIcon right">
          <a-icon type="right" />
        </div>
      </div>
      <div v-for="(itemData, index) in listArr" :key="index" class="itemDiv">
        <car-item v-for="(item, i) in itemData" :key="i" :item="item" :active="value === item.name" :car-norms="carNorms" @click="onChangeCarType(item.name)"></car-item>
      </div>
    </a-carousel>
  </div>
</template>

<script>
import CarItem from './CarItem.vue';

export default {
  name: "CarType",
  components: {
    CarItem,
  },
  model:{
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      default: '',
      type: [String, Number]
    },
    list: {
      type: [Object, Array],
      default: () => {}
    },
    carNorms: {
      default: '',
      type: [String, Number]
    }
  },
  data(){
    return {
    }
  },
  computed: {
    listArr(){
      if(this.list){
        const arr = []
        const data = Object.keys(this.list)
        const carList = data.map((e)=>{
          return {
            name: e,
            weight: this.list[e][0].carAllowWeight,
            volume: this.list[e][0].carVolume,
          }
        })
        while(carList.length > 0){
          arr.push(carList.splice(0,6))
        }
        return arr
      }
        return []
    }
  },
  watch:{
    value:{
      handler (val){
        if(val) {
          this.listArr.forEach((e, i) => {
            e.forEach(n=>{
              if(n.name === val && this.$refs.carousel){
                this.$refs.carousel.goTo(i)
              }
            })
          })
        }
      },
      immediate: true
    },
    listArr:{
      handler (val){
        if(val && val.length > 0) {
          val.forEach((e, i) => {
            e.forEach(n=>{
              if(n.name === this.value && this.$refs.carousel){
                this.$refs.carousel.goTo(i)
              }
            })
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    onChangeCarType(data){
      this.$emit('change', data)
      this.$emit('checkedList', data)
    }
  }
}
</script>

<style lang="less" scoped>
.CarType{
  height: 200px;
}
::v-deep .slick-slide {
  text-align: center;
  height: 204px;
  line-height: 204px;
  background: #F2FBF8;
  border-radius: 6px;
  overflow: hidden;
  > div {
    height: 100%;
  }
}

::v-deep .custom-slick-arrow {
  width: 42px;
  height: 82px;
  font-size: 40px;
  color: #c6c6c7;
  text-align: center;
  line-height: 82px;
  margin-top: -40px;
  &::before{
    display: none;
  }
}

::v-deep .slick-slide h3 {
  color: #fff;
}
.itemIcon{
  width: 42px;
  height: 82px;
  font-size: 40px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  color: #fff;
  &:hover {
    background: rgba(0, 0, 0, 0.6);
  }
}
.itemDiv{
  padding: 0 50px;
  display: flex !important;
  justify-content: flex-start;
  height: 100%;
  align-items: center;
}
::v-deep .itemIcon{
  i{
    font-size: 36px;
  }
}
</style>
